import React, { useState, useEffect } from "react";
import Navb from "../../components/navbar/Navb";
import axios from "axios";
import SideBar from "./SideBar";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
// import { Link } from "react-router-dom";
import "./dashboard.css";
import { useParams } from "react-router-dom";
import API_URL from "../../constants";
const Candidate = () => {
  const [apply, setApply] = useState(false);
  const [data, setData] = useState();
  const [job, setJob] = useState();

  //   const url = window.location.href;
  //   const parts = url.split("/");

  //   // Extracting job_id and candidate_id from the URL
  //   const job_id = parts[parts.length - 1];
  // const candidate_id = parts[parts.length - 2];
  //   console.log("id", candidate_id);
  //   console.log("job_id", job_id);
  const { user_id, job_id } = useParams();
  console.log("user_id", user_id);
  console.log("job_id", job_id);
  const candidate_id = user_id;
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/admin/jobs/${job_id}/candidates/${user_id}`
      );
      console.log("response", response);
      setData(response.data.candidate);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    const fetchJob = async () => {
      try {
        const status = {
          job_id: job_id,
        };
        const response = await axios.get(
          `${API_URL}/applications/job_details`,
          {
            params: status,
          }
        );
        console.log("response", response);
        setJob(response.data.job);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchJob();
  }, [job_id]);

  const shortlistCandidate = async (e) => {
    // e.preventDefault(); // Prevent default form submission behavior

    try {
      const dataToSend = {
        status: "shortlisted",
      };
      const response = await axios.put(
        `${API_URL}/admin/jobs/${job_id}/candidates/${candidate_id}/edit_status`,
        dataToSend
      );
      console.log("Response:", response);
      // console.log("Response data:", data);
      // console.log("Response job:", job);
      if (response.status === 200 || response.status === 201) {
        const dataToSend = {
          to: data.email,
          subject: `Your Job Application for ${job.post} is Shortlisted`,
          message: `
          Dear ${data.name},
          We are pleased to inform you that your job application for the position of ${job.post} at ${job.company_name} has been shortlisted. Congratulations on making it to the next stage of our selection process!

          We will be in touch shortly with further details about the next steps, which may include an interview or additional assessments.

          Thank you for your interest in joining our team at Udaya Solution. We look forward to learning more about you and your qualifications.

          Best regards,
          Udaya Solution Recruitment Team
        `,
        };

        const mailresponse = await axios.post(
          `${API_URL}/send-email`,
          dataToSend
        );
        console.log("mailresponse", mailresponse);

        // if (mailresponse.status === 200 || mailresponse.status === 201) {
        //   alert("submitted successfully!");
        //   // setSuccess(true);
        // }
      }

      alert("successfully! Shortlisted");
    } catch (error) {
      console.error("Error:", error);
      console.error("Error Response:", error.response); // Log the error response
    }
  };

  const rejectCandidate = async () => {
    // e.preventDefault();
    // Check if any field is empty

    const dataToSend = {
      status: "rejected",
    };
    try {
      const response = await axios.put(
        `${API_URL}/admin/jobs/${job_id}/candidates/${candidate_id}/edit_status`,
        dataToSend
      );
      console.log("Response:", response);
      if (response.status === 200 || response.status === 201) {
        const dataToSend = {
          to: data.email,
          subject: `Update on Your Job Application for ${job.post}`,
          message: `Dear ${data.name},

          Thank you for your interest in the ${job.post} position at Udaya Solution and for taking the time to submit your application.

          After careful consideration, we regret to inform you that we have decided not to move forward with your application at this time.

          We appreciate your interest in our company and encourage you to apply for future openings that match your skills and experience.

          We wish you the best in your job search and future career endeavors.

          Best regards,
          Udaya Solution Recruitment Team`,
        };

        const mailresponse = await axios.post(
          `${API_URL}/send-email`,
          dataToSend
        );
        console.log("mailresponse", mailresponse);

        // if (mailresponse.status === 200 || mailresponse.status === 201) {
        //   alert("submitted successfully!");
        //   // setSuccess(true);
        // }
      }

      alert("successfully! Rejected");
    } catch (error) {
      console.error("Error:", error);
      console.error("Error Response:", error.response); // Log the error response
    }
    // Here you can perform further actions like submitting the form data to a server
  };

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     // Check if any field is empty
  //     for (const key in formData) {
  //       if (!formData[key]) {
  //         alert(`Please fill in ${key}`);
  //         return;
  //       }
  //     }
  //     // If all fields are filled, log the form data
  //     // console.log(formData);
  //     // console.log("idd",id);
  //     const dataToSend = {
  //       ...formData, // Spread the formData object
  //       resume: "base64_encoded_resume_data_here",
  //       job_id: id,
  //     };
  //     try {
  //       const response = await axios.post(
  //         `${API_URL}/applications/apply",
  //         dataToSend
  //       );
  //       console.log("Response:", response.data);
  //       setFormData({
  //         name: "",
  //         phone_number: "",
  //         email: "",
  //         location: "",
  //         years_of_experience: "",
  //         current_salary: "",
  //         expected_salary: "",
  //         skills: "",
  //         current_position: "",
  //         current_company: "",
  //         resume: "",
  //       });
  //       // Show a notification message
  //       alert("Form submitted successfully!");
  //     } catch (error) {
  //       console.error("Error:", error);
  //       console.error("Error Response:", error.response); // Log the error response
  //     }
  //     // Here you can perform further actions like submitting the form data to a server
  //   };

  return (
    <>
      <Navb />
      <div className="dashboard">
        <SideBar />
        <section className="rightBar">
          <div className="jobHeader">candidate</div>
          {data && (
            <>
              <Form>
                <div className="allField">
                  <InputGroup className="mb-3">
                    {/* <InputGroup.Text id="basic-addon1">@</InputGroup.Text> */}
                    <Form.Control
                      className="field"
                      placeholder={data.name}
                      aria-label="name"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="name"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.phone_number}
                      aria-label="phone_number"
                      aria-describedby="basic-addon1"
                      type="number"
                      name="phone_number"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.email}
                      aria-label="email"
                      aria-describedby="basic-addon1"
                      type="email"
                      name="email"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.location}
                      aria-label="location"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="location"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.years_of_experience}
                      aria-label="years_of_experience"
                      aria-describedby="basic-addon1"
                      type="number"
                      name="years_of_experience"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.current_salary}
                      aria-label="current_salary"
                      aria-describedby="basic-addon1"
                      type="number"
                      name="current_salary"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.expected_salary}
                      aria-label="expected_salary"
                      aria-describedby="basic-addon1"
                      type="number"
                      name="expected_salary"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.skills}
                      aria-label="skills"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="skills"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.current_position}
                      aria-label="current_position"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="current_position"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.current_company}
                      aria-label="current_company"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="current_company"
                      disabled
                    />
                    <Form.Control
                      className="field"
                      placeholder={data.resume}
                      aria-label="current_company"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="resume"
                      disabled
                    />

                    <a
                      // href={data.resume}
                      href={`http://13.233.197.233:3001/${data.resume}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="submitButton"
                      style={{
                        "text-decoration": "none",
                        "border-radius": "6px",
                      }}
                    >
                      View Resume
                    </a>

                    {/* <Form.Control
                    className="field"
                    placeholder={data.post}
                    aria-label="current_company"
                    aria-describedby="basic-addon1"
                    type="text"
                    name={data.job_id}
                    disabled
                  />
                  <Form.Control
                    className="field"
                    placeholder={data.job_id}
                    aria-label="current_company"
                    aria-describedby="basic-addon1"
                    type="text"
                    name={data.job_id}
                    disabled
                  /> */}
                    {/* <Form.Control
              className="field"
              placeholder="Resume"
              aria-label="resume"
              aria-describedby="basic-addon1"
              type="text"
              name="current_position"
              value={formData.current_position}
              onChange={handleChange}
              required
            /> */}
                  </InputGroup>
                </div>
              </Form>
              <div className="center" style={{ gap: "2rem" }}>
                <button className="submitButton" onClick={shortlistCandidate}>
                  Shortlist
                </button>
                <button className="submitButton" onClick={rejectCandidate}>
                  Reject
                </button>
              </div>
            </>
          )}
        </section>
      </div>
    </>
  );
};

export default Candidate;
